import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Box } from '@/components/blocks/Box';
import { Flex } from '@/components/blocks/Flex';
import { Icon, IconName } from '@/components/blocks/Icon';
import { Text } from '@/components/blocks/Text';

interface Props {
  title: string;
  description: string;
  icon: IconName;
  onClick?: () => void;
}

const Root = styled(Box)(({ theme }) =>
  css({
    padding: theme.spaces.l,
    borderBottom: theme.borders.default,
  })
);

const Content = styled(Flex)(() =>
  css({
    justifyContent: 'space-between',
    alignItems: 'center',
  })
);

const Main = styled(Box)(({ theme }) =>
  css({
    textAlign: 'left',
    marginLeft: theme.spaces.l,
    '& p': {
      display: 'block',
    },
  })
);

export const MenuList = (props: Props) => {
  const { title, description, icon, onClick } = props;

  return (
    <Root onClick={onClick}>
      <Content>
        <Flex alignItems='center'>
          <Icon icon={icon} color='primary' width='32px' />
          <Main>
            <Text use='m-B'>{title}</Text>
            <Text use='xs-N'>{description}</Text>
          </Main>
        </Flex>
        <Icon icon='chevron-right' width='24px' />
      </Content>
    </Root>
  );
};
